import { render } from "./HelloWorld.vue?vue&type=template&id=cd764b9a"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"
script.render = render

export default script